import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_2 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_3 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full sm:pl-16" }
const _hoisted_4 = { class: "relative flex h-full flex-col overflow-y-scroll bg-white dark:bg-gray-700 shadow-xl" }
const _hoisted_5 = { class: "sticky z-40 top-0 bg-primary-600 dark:bg-primary-500 py-6 px-4 sm:px-6" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "ml-3 flex h-7 items-center" }
const _hoisted_8 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_9 = { class: "text-white" }
const _hoisted_10 = { class: "relative flex-1 py-6 px-4 sm:px-6" }
const _hoisted_11 = { class: "absolute inset-0 py-6 px-4 sm:px-6 text-gray-900 dark:text-white" }

import { ref } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'


export default /*@__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
    title: {},
    description: {},
    width: {}
  },
  emits: ["close"],
  setup(__props: any) {

const open = ref(true);

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value,
    onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
      }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "fixed inset-0 bg-black opacity-10" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "transform transition ease-in-out duration-500 sm:duration-700",
                  "enter-from": "translate-x-full",
                  "enter-to": "translate-x-0",
                  leave: "transform transition ease-in-out duration-500 sm:duration-700",
                  "leave-from": "translate-x-0",
                  "leave-to": "translate-x-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), {
                      class: _normalizeClass([
                'pointer-events-auto w-screen',
                _ctx.width ? _ctx.width : 'md:max-w-4xl',
              ])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_unref(DialogTitle), { class: "font-serif text-3xl italic text-white" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.title), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-md bg-primary-600 dark:bg-primary-500 text-primary-200 hover:text-white focus:outline-none",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
                                }, [
                                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Close", -1)),
                                  _createVNode(_unref(XMarkIcon), {
                                    class: "h-6 w-6",
                                    "aria-hidden": "true"
                                  })
                                ])
                              ])
                            ]),
                            (props.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("p", _hoisted_9, _toDisplayString(props.description), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _renderSlot(_ctx.$slots, "default")
                            ])
                          ])
                        ])
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ])
        ]),
        _: 3,
        __: [4]
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})